import {
  type UseUploadImageForSingleQuestionCreationInput,
  useUploadImageForQuestion,
} from '../use-upload-image-for-question-creation';

export function useUploadImageForSingleQuestionCreation(
  params: UseUploadImageForSingleQuestionCreationInput,
) {
  const { questionId, taskId, options } = params;

  return useUploadImageForQuestion({ questionId, taskId, options });
}
